import { render } from "./customizertool.vue?vue&type=template&id=81835aaa"
import script from "./customizertool.vue?vue&type=script&lang=js"
export * from "./customizertool.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__